module.exports = __webpack_public_path__ + "static/media/Video-Script.efc0ab66.docx";